<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch7">
<div class="chapterHead"><p class="centerImage0"><img alt="image" src="images/ch7.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;">You’re terrified of the dog. Then you remember.</p>
<p class="para" style="text-indent: 5%;">Fido can’t kill you.</p>
<p class="para" style="text-indent: 5%;">You’re a vampire! Only a few things can kill you.</p>
<p class="para" style="text-indent: 5%;">A stake through the heart. Being exposed to sunlight. Being burned alive.</p>
<p class="para" style="text-indent: 5%;">You bare your fangs and hiss. The Doberman slinks away, whining.</p>
<p class="para" style="text-indent: 5%;">“Not bad,” Gabe admits.</p>
<p class="para" style="text-indent: 5%;">Oh, by the way. There’s one other thing that can knock you out….</p>
<p class="para" style="text-indent: 5%;">A blood shortage.</p>
<p class="para" style="text-indent: 5%;">Without blood, vampires don’t die. But they become so weak, they can’t move.</p>
<p class="para" style="text-indent: 5%;">That’s what’s happening to you now. With a moan, you collapse.</p>
<p class="extractLetterText" style="text-indent: 5%;"><em class="italic">Uh-oh. Turn to <span href="#/e9780545820660_ch036" title="Link target outside of Sample">PAGE 36</span>.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545820660_ch007.vue?69544cea